import React from 'react';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';

import { ModalId } from 'constants/modalId';
import { ClippingPlatformState } from 'store/clippingPlatformState';
import { createModalCloseAction } from 'actions/modalActions';

export type GuardedModalContentComponentProps<T> = { id: ModalId; open: boolean; close: () => void; data: T };

export function makeGuardedModal<T = unknown>(
  id: ModalId,
  Component: React.ComponentType<GuardedModalContentComponentProps<T> & any>,
) {
  const mapStateToProps = (state: ClippingPlatformState) => {
    const modal = state.appStatus.modals[id];
    const open = modal ? modal.open : false;
    const data = modal ? modal.props : {};

    return { open, data };
  };

  const mapDispatchToProps = (dispatch: Dispatch) => ({
    close: () => dispatch(createModalCloseAction(id)),
  });

  class GuardedModal extends React.Component<
    ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps> & { [x: string]: any }
  > {
    componentWillUnmount(): void {
      const { open, close } = this.props;

      if (open) {
        close();
      }
    }

    render() {
      const { open, close, data, ...props } = this.props;

      if (open) {
        return <Component id={id} open={open} close={close} data={data} {...props} />;
      }

      return null;
    }
  }

  return connect(mapStateToProps, mapDispatchToProps)(GuardedModal);
}
